//#region Public routes
const publicRoutes = {
	// #region homePage
	home: "/",
	homepageSupplier: "/supplier",
	homepageBodyshop: "/bodyshop",
	homepageInsurer: "/insurer",
	homepageAbout: "/about",
	homepageDemo: "/demo",
	homepagePrivacyPolicy: "/privacy-policy",
	homepageCookies: "/cookies",
	//#endregion

	login: "/login",
	evaluationSupplierPublic: "/evaluation/supplier-public",
	supplierRegisterPublic: "/register-supplier",
	bodyshopRegisterPublic: "/register-bodyshop",
};
//#endregion

export class RoutesConstants {
	//#region Private routes
	// Account
	static accountResetPassword: string = "/account/reset-password";

	static accountNewAccount: string = "/account/new-account";

	// Registration
	static registration: string = "/registration";

	static registrationSearchInsurer: string = "/registration/search-insurer";

	static registrationRegisterInsurer: string = "/registration/register-insurer";

	static registrationSearchBodyshop: string = "/registration/search-bodyshop";

	static registrationRegisterBodyshop: string = "/registration/register-bodyshop";

	static registrationSearchSupplier: string = "/registration/search-supplier";

	static registrationRegisterSupplier: string = "/registration/register-supplier";

	static registrationSearchUser: string = "/registration/search-user";

	static registrationRegisterUser: string = "/registration/register-user";

	static registrationSearchUsergroup: string = "/registration/search-usergroup";

	static registrationRegisterUsergroup: string = "/registration/register-usergroup";

	static registrationPartsCatalog: string = "/registration/parts-catalog";

	static registrationPackWorkflow: string = "/registration/pack-workflow";
	static registrationHoliday: string = "/registration/holiday";

	static registrationSearchReportTemplate: string = "/registration/report-template";
	static registrationRegisterReportTemplate: string = "/registration/report-template-registration";
	static registrationSearchValuator: string = "/registration/search-valuator";
	static registrationRegisterValuator: string = "/registration/register-valuator";
	static registrationSearchSupervisor: string = "/registration/search-supervisor";
	static registrationRegisterSupervisor: string = "/registration/register-supervisor";
	static registrationEmailTemplates: string = "/registration/search-email-templates";
	static registrationRegisterEmailTemplate: string = "/registration/edit-email-templates";
	static registrationSearchAnnouncement: string = "/registration/search-announcement";
	static registrationRegisterAnnouncement: string = "/registration/register-announcement";
	static registrationTireBrand: string = "/registration/tire-brand";
	static registrationRegion: string = "/registration/search-region";
	static registrationTermsOfUse: string = "registration/acceptance-terms";
	static registrationSearchBodyshopRates: string = "/registration/search-bodyshop-rates";
	static registrationSearchGuid: string = "/registration/search-guide";
	static registrationSearchApprovalMatrix = "/registration/search-approval-matrix";
	static registrationRegisterApprovalMatrix = "/registration/register-approvalMatrix";

	// Order
	static order: string = "/order";

	static orderSearchOrder: string = "/order/search-orders";

	static orderCreateOrder: string = "/order/create-order";

	static orderPreQuote: string = "/order/pre-quote";

	static orderReassignOrder: string = "/order/reassign-order";

	static orderMappingParts: string = "/order/mapping-parts";

	static orderReassignOrderBulk: string = "/order/bulk-reassign-order";

	static orderManagePackages: string = "/order/manage-packages";
	static partsCancelledBySupplier: string = "/order/manage-parts-cancelled-by-supplier";

	// Quotation
	static quotation: string = "/quotation";

	static quotationCartPendingToAnswer: string = "/quotation/search-cart";

	static quotationCartCreateAnswer: string = "/quotation/answered-cart";

	// Inventory
	static inventory: string = "/inventory";

	static inventorySearchImport: string = "/inventory/search-imports";

	static inventoryRegister: string = "/inventory/register-inventory";

	//Integration
	static integrationSearchIntegrationsLog: string = "/integration/search-integrations-log";

	static integration: string = "/integration";

	static integrationRegister: string = "/integration/register-integration";

	static integrationQueue: string = "/integration/integration-queue";

	static integrationSearchIntegration: string = "/integration/search-integration";

	static integrationMappingCodes: string = "/integration/mapping-codes";

	// Report
	static report: string = "/report";

	static reportOrder: string = "/report/order-report";

	static reportBillingOrder: string = "/report/billing-report";

	static reportShippingCost: string = "/report/shipping-cost-report";

	static reportSupplierPerformance: string = "/report/supplier-performance-report";

	static reportRequoteTraceability: string = "/report/requote-traceability-report";

	static reportOrderReportSchedule: string = "/report/order-report-schedule";

	static reportDynamicReportRegister: string = "/report/dynamic-report-configuration";

	static dynamicReport: string = "/report/dynamic-report";

	static dynamicReportConfiguration: string = "/report/dynamic-report-configuration";

	// Report
	static claim: string = "/claim";

	static claimSearchClaims: string = "/claim/search-claims";

	static claimSearchRefund: string = "/claim/search-refund";

	// General
	static home: string = "/";
	static homepageSupplier: string = "/supplier";
	static homepageBodyshop: string = "/bodyshop";
	static homepageInsurer: string = "/insurer";
	static homepageAbout: string = "/about";
	static homepageDemo: string = "/demo";
	static homepagePrivacyPolicy: string = "/privacy-policy";
	static homepageCookies: string = "/cookies";

	static notFound: string = "/not-found";
	//#endregion

	//#region Public routes
	static login: string = publicRoutes.login;
	static evaluationSupplierPublic: string = publicRoutes.evaluationSupplierPublic;
	static supplierRegisterPublic: string = publicRoutes.supplierRegisterPublic;
	static bodyshopRegisterPublic: string = publicRoutes.bodyshopRegisterPublic;
	//#endregion
}
export type TypeRoutesConstants = keyof typeof RoutesConstants;

// Functions
export function getPublicRoutes() {
	return Object.values(publicRoutes);
}
